import { AxiosError } from 'axios';
import { ErrorCodes } from '@ringana/errors';
import { EErrorMessage } from '../common/enums/messages.enum';

export default class ValidationError extends Error {
  constructor(public readonly errorCode: ErrorCodes,
              public readonly axiosError: AxiosError,
              public readonly errorMessage?: EErrorMessage) {
    super(EErrorMessage.VALIDATION_FAILED.toString());
    Object.setPrototypeOf(this, ValidationError.prototype);
  }
}
